module.exports = __webpack_public_path__ + "static/media/amazon-logo.ed6b5e83.png";